import type { NativeAdmissionPort } from "../platform/Platform";
import {
    addAdmissionInvalidatedListener,
    clearAdmittedScope,
    getTenantScopeCapabilities,
    installAdmittedScope,
} from "./nativeNav";

/** The iOS app's native half of an admitted project: the NativeNav plugin's admitted-scope
 *  calls (NativeNavPlugin.swift). */
export const nativeNavAdmission: NativeAdmissionPort = {
    // Each call reads the plugin when it runs, not when this module loads.
    capabilities: () => getTenantScopeCapabilities(),
    install: (scope) => installAdmittedScope(scope),
    clear: ({ ownerId, sequence, revokeOffline }) =>
        clearAdmittedScope(ownerId, sequence, revokeOffline),
    async onInvalidated(listener) {
        const handle = await addAdmissionInvalidatedListener(listener);
        return () => void handle.remove();
    },
};
